<template>
  <div class="flex flex-row items-center mb-1">
    <template v-if="validationError">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="margin-top: 2px"
      >
        <circle
          cx="9"
          cy="9"
          r="8.5"
          fill="white"
          :class="
            color === 'green'
              ? 'stroke-green'
              : color === 'yellow'
              ? 'stroke-yellow'
              : color === 'blue'
              ? 'stroke-blue'
              : color === 'orange'
              ? 'stroke-orange'
              : color === 'purple'
              ? 'stroke-purple'
              : color === 'indigo'
              ? 'stroke-indigo'
              : color === 'red'
              ? 'stroke-red'
              : color === 'pink'
              ? 'stroke-pink'
              : ''
          "
        />
        <path
          :class="
            color === 'green'
              ? 'fill-green'
              : color === 'yellow'
              ? 'fill-yellow'
              : color === 'blue'
              ? 'fill-blue'
              : color === 'orange'
              ? 'fill-orange'
              : color === 'purple'
              ? 'fill-purple'
              : color === 'indigo'
              ? 'fill-indigo'
              : color === 'red'
              ? 'fill-red'
              : color === 'pink'
              ? 'fill-pink'
              : ''
          "
          d="M8.99999 2.60001C7.94207 2.60001 7.12728 3.53345 7.27022 4.58167L8.0919 10.6073C8.15382 11.0615 8.54168 11.4 8.99999 11.4C9.4583 11.4 9.84616 11.0615 9.90808 10.6073L10.7298 4.58167C10.8727 3.53345 10.0579 2.60001 8.99999 2.60001Z"
        />
        <path
          :class="`fill-${color}`"
          d="M8.99999 15.4C9.88365 15.4 10.6 14.6837 10.6 13.8C10.6 12.9164 9.88365 12.2 8.99999 12.2C8.11633 12.2 7.39999 12.9164 7.39999 13.8C7.39999 14.6837 8.11633 15.4 8.99999 15.4Z"
        />
      </svg>
    </template>

    <template v-else-if="success">
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        style="margin-top: 2px"
      >
        <circle cx="10" cy="10" r="10" :class="`fill-${color}`" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.7374 5.76256C17.4209 6.44598 17.4209 7.55402 16.7374 8.23744L8.73744 16.2374C8.05402 16.9209 6.94598 16.9209 6.26256 16.2374L3.26256 13.2374C2.57915 12.554 2.57915 11.446 3.26256 10.7626C3.94598 10.0791 5.05402 10.0791 5.73744 10.7626L7.5 12.5251L14.2626 5.76256C14.946 5.07915 16.054 5.07915 16.7374 5.76256Z"
          fill="#fff"
        />
      </svg>
    </template>

    <!-- TODO Add other statuses -->

    <template v-else>
      <svg
        viewBox="0 0 16 16"
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="8" :class="`fill-${color}`" />
      </svg>
    </template>

    <!-- <circle-icn
      width="16"
      height="16"
      v-if="!optional && status == 0"
      :class="`fill-${color}`"
      style="margin-top: 2px"
    ></circle-icn>
    <template v-else>
      <svg
        v-if="status == 1"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
      >
        <circle cx="10" cy="10" r="10" :class="`fill-${color}`" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.7374 5.76256C17.4209 6.44598 17.4209 7.55402 16.7374 8.23744L8.73744 16.2374C8.05402 16.9209 6.94598 16.9209 6.26256 16.2374L3.26256 13.2374C2.57915 12.554 2.57915 11.446 3.26256 10.7626C3.94598 10.0791 5.05402 10.0791 5.73744 10.7626L7.5 12.5251L14.2626 5.76256C14.946 5.07915 16.054 5.07915 16.7374 5.76256Z"
          fill="#fff"
        />
      </svg>

      <svg
        v-else-if="status == -1"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="8.5" fill="white" :class="`stroke-${color}`" />
        <path
          :class="`fill-${color}`"
          d="M8.99999 2.60001C7.94207 2.60001 7.12728 3.53345 7.27022 4.58167L8.0919 10.6073C8.15382 11.0615 8.54168 11.4 8.99999 11.4C9.4583 11.4 9.84616 11.0615 9.90808 10.6073L10.7298 4.58167C10.8727 3.53345 10.0579 2.60001 8.99999 2.60001Z"
        />
        <path
          :class="`fill-${color}`"
          d="M8.99999 15.4C9.88365 15.4 10.6 14.6837 10.6 13.8C10.6 12.9164 9.88365 12.2 8.99999 12.2C8.11633 12.2 7.39999 12.9164 7.39999 13.8C7.39999 14.6837 8.11633 15.4 8.99999 15.4Z"
        />
      </svg>

      <span v-else style="width: 16px;"></span>
    </template> -->
    <span class="text-lg font-bold ml-1" :class="`text-${color}`">{{
      label
    }}</span>
    <span v-if="message" class="text-lg" :class="`text-${color}`">
      ｜{{ message }}
    </span>
    <slot name="message">
      <span class="text-lg" :class="`text-${color}`"></span>
    </slot>
  </div>
</template>

<script>
// import CircleIcn from "@/assets/icons/circle.svg?inline";

export default {
  name: 'AppInputStatus',

  components: {
    // CircleIcn,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'blue',
    },
    optional: {
      type: Boolean,
      default: false,
    },
    validationError: Boolean, // input validation status
    edit: Boolean, // edit status
    success: Boolean, // no validation error - success status
    // status: Number // -10 - rejected, -1 - validationError; 1 - success, 10 - approved
  },

  setup() {},
}
</script>

<style lang="scss">
svg.fill-blueSecondary {
  circle {
    fill: theme('colors.blueSecondary') !important;
  }
}
</style>
